module.exports = __webpack_public_path__ + "static/DScrop-23ab274d2e2cd68127d4525f2b990da6.png";